/**
 * Timeline
 * ------
 */

$("#view-timeline").on('click', function(event) {
    event.preventDefault();
    //console.log('view timeline');

    $('#timeline').slideToggle();
    var targetOffset = $('#timeline').offset().top - 70;
    $("html, body").animate({ scrollTop: targetOffset }, 500);
    
    
});

$('.scroll-timeline').on('init', function() {
    $(".scroll-timeline .year-mark:first-child").addClass('current');
});

// about us page timeline slider
$('.scroll-timeline').slick({
    centerMode: true,
    // dots: true,
    // appendArrows: $('.years .years-holder'),
    arrows: true,
    infinite: false,
    variableWidth: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [
    {
      breakpoint: 900,
      settings: {
        dots: false,
        slidesToShow: 1,
      }
    },
    {
      breakpoint: 700,
      settings: {
        dots: false,
        slidesToShow: 1,
      }
    },

    ]
});

$('.scroll-timeline').on('afterChange', function() {
    var dataYear = $('.scroll-timeline .slick-current').attr("data-year"); 
    var dataIndex = $('.scroll-timeline .slick-current').attr("data-slick-index");  
    var dataType = $('.scroll-timeline .slick-current').attr("data-type");  
    //console.log(dataYear + " - " + dataIndex + " - " + dataType);

    $('.years a').removeClass('current');
    $(".years").find("[data-id='year-tab-" + dataYear + "']").addClass('current');
    if(!$(".scroll-timeline .year-mark[data-year='"+dataYear+"']").hasClass('current')) {
        $('.scroll-timeline .year-mark').removeClass('current');
        $(".scroll-timeline .year-mark[data-year='"+dataYear+"']").addClass('current');
    }

});

// year click 
$(".years a").on('click', function(event) {
    event.preventDefault();
    var dataYear = $(this).attr("data-year");
    
    yearChange(dataYear);
    //var currentSlide = $('.scroll-timeline').slick('slickCurrentSlide');
    //console.log(currentSlide);
});
$('.years .years-previous').on('click', function() {
    var currentYear = $('.years .date.current'),
        prevYear = currentYear.prev('.date');

    if(prevYear.length) {
        currentYear.removeClass('current');
        prevYear.addClass('current');
        yearChange(prevYear.attr('data-year'));
    }
});
$('.years .years-next').on('click', function() {
    var currentYear = $('.years .date.current'),
        nextYear = currentYear.next('.date');

    if(nextYear.length) {
        currentYear.removeClass('current');
        nextYear.addClass('current');
        yearChange(nextYear.attr('data-year'));
    }
});
function yearChange(year) {
    var goTo = $(".scroll-timeline").find("[data-year='" + year + "']").attr("data-slick-index");
    $('.scroll-timeline').slick('slickGoTo', goTo);
}

// timeline video
var videoSrc = "";

$("a.video-modal-watch").on('click', function(event) {
    event.preventDefault();
    videoSrc = "https://www.youtube.com/embed/" + $(this).attr("data-video") + "?rel=0&autoplay=1&showinfo=0";
});

// stop video when modal is closed
$('#eventModal').on('shown.bs.modal', function (e) {
    $("#eventModal iframe").attr('src', videoSrc);
});

// stop video when modal is closed
$('#eventModal').on('hide.bs.modal', function (e) {
    // console.log("stop video");
    $("#eventModal iframe").attr('src', '');
});